import type { ClusterOutlierPoint } from '@avisoma/shared';

export function ClusterTooltip({
  active,
  payload,
}: {
  active?: boolean;
  payload?: Array<{ payload: ClusterOutlierPoint }>;
}) {
  if (!active || !payload?.length) {
    return null;
  }
  const point = payload[0].payload;
  return (
    <div className="rounded-md border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-800 px-3 py-2 text-xs shadow dark:shadow-zinc-950/30">
      <div className="font-semibold text-gray-900 dark:text-zinc-100">Cluster {point.id}</div>
      <div className="text-gray-500 dark:text-zinc-400">{point.pageCount} pages</div>
      <div className="text-gray-500 dark:text-zinc-400">Distance: {point.distance.toFixed(3)}</div>
    </div>
  );
}
